(function() {
    'use strict';
    
a3_cabin_reports.factory('IncompleteServicesSourceFactory', IncompleteServicesSourceFactory);

    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name IncompleteInFlightServicesFactory
    * @description 
    *   Manage Incomplete In-Flight Services Reasons.
    * @ngInject
    */
function IncompleteServicesSourceFactory(localStorageMD5Service) {

		
		var service = {
            setIncompleteInFlightServiceListOfValues: setIncompleteInFlightServiceListOfValues,
            getA3ReasonsFromStorage: getA3ReasonsFromStorage,
            getOAReasonsFromStorage: getOAReasonsFromStorage,
            getA3ServicesFromStorage: getA3ServicesFromStorage,
            getOAServicesFromStorage: getOAServicesFromStorage
        };

		//Get From LocalStorage
        /**
         * Get all the Incomplete In-Flight Services Reasons for A3
         * @memberof IncompleteInFlightServicesFactory
         * @returns {array} TravelValueIncompleteReasons
         */
		function getA3ReasonsFromStorage() {
            var results = [];
            var listOfValues = localStorageMD5Service.get('incompleteInFlightServiceListOfValues');
            if(listOfValues){
                var A3Reasons = listOfValues.filter(function (item) {
                    return item.Fleet == "A3" && item.Type == "Reason";
                });
                results = A3Reasons.map(function (item) {
                    return item.Value;
                });
            }
			return (results);
        }
        /**
         * Get all the Incomplete In-Flight Services Reasons for OA
         * @memberof IncompleteInFlightServicesFactory
         * @returns {array} TravelValueIncompleteReasons
         */
		function getOAReasonsFromStorage() {
            var results = [];
            var listOfValues = localStorageMD5Service.get('incompleteInFlightServiceListOfValues');
            if(listOfValues){
                var OAReasons = listOfValues.filter(function (item) {
                    return item.Fleet == "OA" && item.Type == "Reason";
                });
                results = OAReasons.map(function (item) {
                    return item.Value;
                });
            }
			return (results);
        }
        /**
         * Get all the Incomplete In-Flight Services Types for A3
         * @memberof IncompleteInFlightServicesFactory
         * @returns {array} TravelValueIncompleteReasons
         */
		function getA3ServicesFromStorage() {
            var results = [];
            var listOfValues = localStorageMD5Service.get('incompleteInFlightServiceListOfValues');
            if(listOfValues){
                var A3Services = listOfValues.filter(function (item) {
                    return item.Fleet == "A3" && item.Type == "ServiceType";
                });
                results = A3Services.map(function (item) {
                    return item.Value;
                });
            }
			return (results);
        }
        /**
         * Get all the Incomplete In-Flight Services Types for OA
         * @memberof IncompleteInFlightServicesFactory
         * @returns {array} TravelValueIncompleteReasons
         */
		function getOAServicesFromStorage() {
            var results = [];
            var listOfValues = localStorageMD5Service.get('incompleteInFlightServiceListOfValues');
            if(listOfValues){
                var A3Services = listOfValues.filter(function (item) {
                    return item.Fleet == "OA" && item.Type == "ServiceType";
                });
                results = A3Services.map(function (item) {
                    return item.Value;
                });
            }
			return (results);
		}
    //Set to LocalStorage
        /**
         * Set all the Incomplete In-Flight Services List Of Values 
         * @memberof IncompleteInFlightServicesFactory
         * @param {array} objects A list of IncompleteInFlightServicesFactory.
         */
        function setIncompleteInFlightServiceListOfValues (data){
            localStorageMD5Service.set('incompleteInFlightServiceListOfValues', data);
        }

		return service;
	}

})();